import script from "./Report_Pages.vue?vue&type=script&setup=true&lang=js"
export * from "./Report_Pages.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__